import { useEffect, useState, useCallback } from "react";
import { useFlowsTemplates } from "../../../stores/flowsTemplatesStore";

export interface UseTemplatesTabReturn {
  templates: ReturnType<typeof useFlowsTemplates>["templates"];
  templatesLoading: boolean;
  error: string | null;
  createModalOpen: boolean;
  openCreateModal: () => void;
  closeCreateModal: () => void;
}

export function useTemplatesTab(): UseTemplatesTabReturn {
  const {
    templates,
    templatesLoading,
    error,
    fetchTemplates,
  } = useFlowsTemplates();
  const [createModalOpen, setCreateModalOpen] = useState(false);

  useEffect(() => {
    fetchTemplates();
  }, [fetchTemplates]);

  const openCreateModal = useCallback(() => setCreateModalOpen(true), []);
  const closeCreateModal = useCallback(() => setCreateModalOpen(false), []);

  return {
    templates,
    templatesLoading,
    error,
    createModalOpen,
    openCreateModal,
    closeCreateModal,
  };
}
